'use client';

import { useIntl } from 'react-intl';
import {
  PowerSupply,
  type PowerSupplyProps,
} from '@packages/shared/src/ui/PowerSupply/PowerSupply';
import { powerSupplyMessages } from './messages';

export type PowerSupplyLocalizedProps = Omit<PowerSupplyProps, 'powerSupplyMessage'>;

export const PowerSupplyLocalized = ({
  powerSupplyIncluded,
  ...props
}: PowerSupplyLocalizedProps) => {
  const { formatMessage } = useIntl();

  return (
    <PowerSupply
      powerSupplyMessage={formatMessage(
        powerSupplyIncluded === 'included'
          ? powerSupplyMessages.included
          : powerSupplyMessages.notIncluded,
      )}
      powerSupplyIncluded={powerSupplyIncluded}
      {...props}
    />
  );
};
